import { OverlayProvider } from '@react-aria/overlays';
import React from 'react';
import { ThemeProvider as ThemeUiThemeProvider } from 'theme-ui';
import Prism from '@theme-ui/prism';
import theme from '../../theme';

const components = {
    pre: ({ children }: React.PropsWithChildren<unknown>) => <>{children}</>,
    code: Prism,
};

export default function CarrotThemeProvider({ children }: React.PropsWithChildren<unknown>): JSX.Element {
    return (
        <OverlayProvider>
            <ThemeUiThemeProvider {...{ theme, components, children }} />
        </OverlayProvider>
    );
}

export * from '../../theme';
